import { render } from "./DependentRegisterComponent.vue?vue&type=template&id=2687dbc8&scoped=true"
import script from "./DependentRegisterComponent.vue?vue&type=script&lang=js"
export * from "./DependentRegisterComponent.vue?vue&type=script&lang=js"

import "./DependentRegisterComponent.vue?vue&type=style&index=0&id=2687dbc8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2687dbc8"]])

export default __exports__